export const isValidStreamUrl = (u) => /^https:\/\/[^\s]+\.[^\s]+/.test((u || "").trim());

export const liveStreamingLinks = (arr) =>
  (Array.isArray(arr) ? arr : []).filter((s) => s && s.enabled !== false && isValidStreamUrl(s.url));
